import html_default from "./template.default.html?raw";
const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("default" == app_theme) {
  html = html_default;
}
import { ref, computed, onMounted, type SetupContext } from "vue";
import type { CourseDto } from "../../shared/CourseDto.ts";
import type { CourseLessonDto } from "../../shared/CourseLessonDto.ts";
import type { CartDto } from "../../shared/CartDto.ts";

interface Props {
  course: CourseDto;
  courseLesson: CourseLessonDto[];
  cart: CartDto | null;
}

// Schritt 1: Kurs-Kopf, Lektionen einklappbar, Wahl Einzelperson oder Paar
export default {
  template: html,
  emits: {
    onChange: (value: boolean) => typeof value === "boolean",
  },
  props: {
    course: { type: Object, required: true },
    courseLesson: { type: Array, required: true },
    cart: { type: Object, required: false, default: null },
  },
  setup(props: Props, { emit }: SetupContext) {
    const lessonsOpen = ref(false);
    const selected = ref<boolean | null>(null);

    const formatDate = function (dateStr: string | number) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("de-CH", { weekday: "long", day: "numeric", month: "long", year: "numeric" });
    };
    const formatShort = function (dateStr: string | number) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("de-CH", { weekday: "short", day: "2-digit", month: "2-digit", year: "numeric" });
    };
    const formatTime = function (dateStr: string) {
      const date = new Date(dateStr);
      return date.toLocaleTimeString("de-CH", { hour: "2-digit", minute: "2-digit" });
    };
    const money = (v: number) => `CHF ${(v ?? 0).toFixed(2)}`;

    const courseStart = computed(() => (props.course ? formatDate(props.course.dateStart) : ""));
    const courseTime = computed(() => (props.course?.defaultTime ? props.course.defaultTime.substring(0, 5) : ""));
    const freePlaces = computed(function () {
      const max = props.course?.maxParticipants ?? 0;
      if (max <= 0) {
        return null;
      }
      return Math.max(0, max - (props.course?.totalParticipants ?? 0));
    });
    const placesHint = computed(function () {
      if (!props.course?.isAvailable) {
        return "Ausgebucht";
      }
      if (freePlaces.value === null || freePlaces.value > 6) {
        return "";
      }
      return freePlaces.value == 1 ? "Noch 1 Platz frei" : `Noch ${freePlaces.value} Plätze frei`;
    });
    const lessonCount = computed(() => props.courseLesson.length || props.course?.lessonCount || 0);

    const choose = function (isPair: boolean) {
      selected.value = isPair;
      emit("onChange", isPair);
    };

    onMounted(function () {
      if (props.cart) {
        selected.value = props.cart.isPairBooking;
      }
    });

    return {
      props,
      lessonsOpen,
      selected,
      courseStart,
      courseTime,
      freePlaces,
      placesHint,
      lessonCount,
      formatShort,
      formatTime,
      money,
      choose,
    };
  },
};
